import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const CALCULATE_AMOUNT_RESET = 'travelExpense/CALCULATE_AMOUNT_RESET';
const GET_REGIONS_AND_COUNTRIES_SUCCESS = 'travelExpense/GET_REGIONS_AND_COUNTRIES_SUCCESS';
const GET_REGIONS_AND_COUNTRIES_FAIL = 'travelExpense/GET_REGIONS_AND_COUNTRIES_FAILURE';

const NEW_ADD_HARCIRAH = 'travelExpense/NEW_ADD_HARCIRAH';
const NEW_ADD_HARCIRAH_SUCCESS = 'travelExpense/NEW_ADD_HARCIRAH_SUCCESS';
const NEW_ADD_HARCIRAH_FAIL = 'travelExpense/NEW_ADD_HARCIRAH_FAILURE';

const TRAVEL_EXPENSE_CONFIGURATION = 'travelExpense/TRAVEL_EXPENSE_CONFIGURATION';
const TRAVEL_EXPENSE_CONFIGURATION_SUCCESS = 'travelExpense/TRAVEL_EXPENSE_CONFIGURATION_SUCCESS';
const TRAVEL_EXPENSE_CONFIGURATION_FAIL = 'travelExpense/TRAVEL_EXPENSE_CONFIGURATION_FAIL';

const REQUEST_STATS = 'auth/REQUEST_STATS';
const REQUEST_STATS_SUCCESS = 'auth/REQUEST_STATS_SUCCESS';
const REQUEST_STATS_FAIL = 'auth/REQUEST_STATS_FAIL';

const CLEAR = 'auth/CLEAR';

const initialState = {
  index: -1,
  countries: [],
  configuration: {},
  amount: {},
  requestStats: {},
  clear: false,
  alert: {
    show: false,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_REGIONS_AND_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.result.data,
      };

    case GET_REGIONS_AND_COUNTRIES_FAIL:
      return {
        ...state,
        error: action.error.data
      };

    case CALCULATE_AMOUNT_RESET:
      return {
        ...state,
        index: -1,
      };

    case NEW_ADD_HARCIRAH:
      return {
        ...state,
      };

    case NEW_ADD_HARCIRAH_SUCCESS:
      return {
        ...state,
        clear: true,
      };

    case NEW_ADD_HARCIRAH_FAIL:
      return {
        ...state,
        error: action.error.data
      };

    case REQUEST_STATS:
      return {
        ...state,
      };

    case REQUEST_STATS_SUCCESS:
      return {
        ...state,
        requestStats: action.result.data,
      };

    case REQUEST_STATS_FAIL:
      return {
        ...state,
        error: action.error.data
      };

    case CLEAR:
      return {
        ...state,
        clear: false,
      };

    case TRAVEL_EXPENSE_CONFIGURATION:
      return {
        ...state,
      };

    case TRAVEL_EXPENSE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configuration: action.result.data,
      };

    case TRAVEL_EXPENSE_CONFIGURATION_FAIL:
      return {
        ...state,
        error: action.error.data
      };

    default:
      return state;
  }
}

export function clear() {
  return {
    type: CLEAR,
  };
}

export function getRequestStats() {
  return {
    types: [REQUEST_STATS, REQUEST_STATS_SUCCESS, REQUEST_STATS_FAIL],
    promise: client => client.post('/harcirah/stats', { data: {} }),
  };
}
export function getTravelExpenseConfigurations(payload) {
  return {
    types: [
      TRAVEL_EXPENSE_CONFIGURATION,
      TRAVEL_EXPENSE_CONFIGURATION_SUCCESS,
      TRAVEL_EXPENSE_CONFIGURATION_FAIL],
    payload,
    promise: client => client.post('/harcirah/configuration', { data: payload }),
  };
}
export function addHarcirah(payload) {
  return {
    types: [NEW_ADD_HARCIRAH, NEW_ADD_HARCIRAH_SUCCESS, NEW_ADD_HARCIRAH_FAIL],
    loading: true,
    promise: client => client.post('/harcirah/add', {
      data: {
        data: payload,
      },
    }),
  };
}
export function getRegionsAndCountries() {
  return {
    types: [
      null,
      GET_REGIONS_AND_COUNTRIES_SUCCESS,
      GET_REGIONS_AND_COUNTRIES_FAIL],
    promise: client => client.post('/getRegionsAndCountries', { data: {} }),
  };
}
export function resetCalculate() {
  return {
    type: CALCULATE_AMOUNT_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/travelExpense.js